import classNames from 'classnames';
import { ReactNode } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Horizontal, SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { BodyM } from '@sorare/core/src/atoms/typography';

type Color = 'green' | 'yellow' | 'red';

interface Props {
  message: MessageDescriptor;
  value: number | string;
  icon: ReactNode;
  iconColor?: Color;
}

const Logo = styled(Horizontal).attrs({ gap: 0, center: true })`
  margin-right: var(--unit);
  width: var(--triple-unit);
  border-radius: var(--intermediate-unit);
  color: var(--c-white);
  text-align: center;
  &.green {
    color: var(--c-green-600);
  }
  &.yellow {
    color: var(--c-yellow-400);
  }
  &.red {
    color: var(--c-red-600);
  }
`;

export const InfoLineWithLogoAndValue = ({
  message,
  value,
  icon,
  iconColor,
}: Props) => {
  const { formatMessage } = useIntl();

  return (
    <SBHorizontal>
      <Horizontal gap={0}>
        <Logo className={classNames(iconColor)}>{icon}</Logo>
        <BodyM as="p">{formatMessage(message)}</BodyM>
      </Horizontal>
      <BodyM as="p" bold>
        {value}
      </BodyM>
    </SBHorizontal>
  );
};
